import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  Injectable,
} from "@angular/core";
import { CommonService } from "../service/common.service";
import { HttpClient } from "@angular/common/http";
import { PersonService } from "../service/person.service";
import { AdminshareService } from "../service/adminshare.service";
import { ShareService } from "../service/share.service";
import { MonshinService } from "../service/monshin.service";
import { YoyakuService } from "../service/yoyaku.service";
import { UsersService } from "../service/users.service";
import {
  Router,
  ActivatedRoute,
  RouterEvent,
  NavigationEnd,
} from "@angular/router";
import { Location } from "@angular/common";

import { Role } from "../app.constant";
import {
  NgbInputDatepicker,
  NgbDatepickerI18n,
  NgbDateStruct,
} from "@ng-bootstrap/ng-bootstrap";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { AViewTextModalComponent } from "../a0106-mail/a-view-text-modal.component";
import { AOutputModalComponent } from "./a-output-modal.component";
import { OutputService } from "../service/output.service";
import { MailService } from "../service/mail.service";
import { FileUploadService } from "../service/fileupload.service";

import { SearchAnswerModalComponent } from "./search-answer-modal.component";
import { AYoyakuMemoModalComponent } from "./a-yoyaku-memo-modal.component";
import { SearchYoyakuDayModelComponent } from "./search-yoyaku-day-model.component";
import { YoyakuPropertyModelComponent } from "./yoyaku-property-model.component";
import { forEach } from "@angular/router/src/utils/collection";
import { FormControl, Validators } from "@angular/forms";

import { PdfService } from "../service/pdf.service";

// マイナビ追加20250930
import { UploadService } from "../service/upload.service";

const I18N_VALUES = {
  ja: {
    weekdays: ["月", "火", "水", "木", "金", "土", "日"],
    months: [
      "1月",
      "2月",
      "3月",
      "4月",
      "5月",
      "6月",
      "7月",
      "8月",
      "9月",
      "10月",
      "11月",
      "12月",
    ],
  },
};

@Injectable()
export class I18n {
  language = "ja";
}
@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
  constructor(private _i18n: I18n) {
    super();
  }
  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }
}
@Component({
  selector: "person-app",
  templateUrl: "./person.component.html",
  styleUrls: ["person.component.css"],
  providers: [
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
  ],
})
export class PersonComponent implements OnInit {
  @ViewChild("pastHistoryReference") pasthistory_reference: ElementRef;
  @Input() event_id: number;
  // マイナビ追加20250930
  @ViewChild("video") videoRef: ElementRef;
  @ViewChild("fileInput") fileInput: ElementRef;

  // マイナビ追加20250930
  selectedFiles: File[] = [];
  selectedFileNames: string[] = [];
  selecteduploadList: any = [];
  examination_target_flg: any;
  upload_required_flg: number;
  upload_flg: any;
  isCameraActive: boolean = false;
  previewUrl: string = null;
  mediaStream: any = null;
  title: string = "受検者一覧";
  reinspectionUnuploadedFlg: boolean = false;

  page: number = 1;
  all_count: number = 0;
  display_per_page: number = 20; /* 最大表示件数 */

  selected: boolean = false;
  datalist: any = [];
  all_datalist: any = [];
  selectedList: any = [];
  person_all_select: boolean = false;

  // 面談flg
  mendan_flg: any;
  online_flg: any;
  mendan_ishi_flg: any;
  hiro_list: any;

  //Form
  search: any = [];
  inputCode: any;
  inputName: any;
  inputCompany: any;
  inputSyozoku: any;
  inputMendandayFrom: any;
  inputMendandayTo: any;
  inputHiro: any;
  inputSuimin: any;
  inputInterviewer: any;

  searchJigyoba: any = [];
  searchSyokuba: any = [];
  searchJigyosyo: any = [];
  searchYakusyoku: any = [];
  searchMibun: any = [];

  search_item: any = {
    t_event_id: null,
    t_person_code: null,
    m_person_code: null,
    t_person_name: null,
    t_person_birthday: null,
    mendan_from: null,
    mendan_to: null,
    m_hiro_hantei_id: new FormControl(),
    m_suimin_hantei_id: new FormControl(),
    mendan_user_id: new FormControl(),
    yoyaku_date: null,
    answer_status: [],
    yoyaku_status: [],
  };

  //編集フォーム
  edit: any = [];
  editItem: any = [];

  selectedCategory: any = null;

  event: any = [];
  selected_event_id: number = null;

  language_list: any = [];
  import_language_id: number = null;
  import_history_list: any = [];
  importFile: any;
  import_yoyakuhyo_id: number = null;
  import_division_id: number = null;

  //SJIS変換
  selectInputFile: any = "";
  SJIScheck: boolean = true;
  checkS: number;

  canOutputFlg: boolean = false;
  output_language_id: number = null;
  output_history_list: any = [];

  file_selected: boolean = false;

  isLoaded: boolean = false;

  //検索モーダル
  search_answer_list: any = [];
  search_tqc_id: any = [];
  search_answer_mode: boolean = false;

  search_yoyaku_date: any = [];
  yoyaku_sort: number = 0;

  yoyakuhyo_list: any = [];
  division_list: any = [];

  hitstory_data: any[] = [];
  is_loaded: boolean = false;

  differencialDownload: boolean = false;

  ROLE: any = Role;
  private previousUrl: string = undefined;
  private currentUrl: string = undefined;

  // ファイルアップロード機能（管理者）マイナビ202607 start
  // 差し替えフラグ
  replaceFlg: boolean = false;
  // 再検査アップロード済
  saikenUploadFlg: boolean = false;
  // ファイルアップロード機能（管理者）マイナビ202607 end

  constructor(
    public commonService: CommonService,
    private personService: PersonService,
    private adminShareService: AdminshareService,
    private shareService: ShareService,
    private monshinService: MonshinService,
    private modalService: NgbModal,
    public usersService: UsersService,
    public outputService: OutputService,
    private yoyakuService: YoyakuService,
    private mailService: MailService,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private fileUploadService: FileUploadService,
    private pdfService: PdfService,
    private uploadService: UploadService,
  ) {
    this.currentUrl = this.router.url;
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      }
    });
  }

  ngOnInit(): void {
    this.selected_event_id = +this.route.snapshot.paramMap.get("eid");
    let searchItem = this.adminShareService.search_item;

    if (searchItem != null) {
      //何かしら情報を保持した状態で遷移した場合
      //基本的には検索条件が入ってくるので絞り込んだリストを取得
      //検索FormにBindしないといけない
      if (searchItem["t_company_id"] != null) {
        this.inputCompany = searchItem["t_company_id"];
      }
      if (searchItem["t_syozoku_code"] != null) {
        this.inputSyozoku = searchItem["t_syozoku_code"];
      }
      if (searchItem["category_list"] != null) {
        this.selectedCategory = searchItem["category_list"];
      }

      //データを取り切った後は念のため初期化しておく
      this.adminShareService.search_item = null;
    }
    //値も何も渡されていない場合(全件取得)
    this.searchPerson();
  }

  /**
   * 検索条件のリセット
   *
   */
  searchItemClearAll() {
    this.search_item.t_person_code = null;
    this.search_item.m_person_code = null;
    this.search_item.t_person_name = null;
    this.search_item.t_person_birthday = null;
    this.search_item.mendan_from = null;
    this.search_item.mendan_to = null;
    this.search_item.m_hiro_hantei_id.reset();
    this.search_item.m_suimin_hantei_id.reset();
    this.search_item.mendan_user_id.reset();
    this.search_item.yoyaku_date = null;
    this.search_item.answer_status = [];
    this.search_item.yoyaku_status = [];
  }

  clearData(): void {
    this.isLoaded = false;
    this.datalist = [];
  }
  edit_person(row): void {
    if (this.selected) {
      this.commonService.modalOpens(
        50005,
        //編集中の内容を破棄してもよろしいですか？
        (modalresult) => {
          if (modalresult == "OK") {
            this.editSelectRowData(row);
            //画面上部へ移動
            window.scrollTo(0, 0);
          } else {
            return;
          }
        },
      );
    } else {
      this.editSelectRowData(row);
      //画面上部へ移動
      window.scrollTo(0, 0);
    }
  }
  editSelectRowData(row: any): void {
    if (row == undefined) {
      //新規追加を許すならここに追加
    } else {
      this.personService.getHistory(row.t_person_id).subscribe(
        (res: Response) => {
          if (res["fuel_status"] == "OK") {
            this.selected = true;
            this.editItem = JSON.parse(JSON.stringify(row));
            this.editItem.birthday = this.commonService.exchangeDateFormat1(
              this.editItem.birthday,
            );
            this.editItem.examination_target_flg =
              this.commonService.exchange01toTF(
                this.editItem.examination_target_flg,
              );
            for (let i = 0; i < this.editItem.saiken_file.length; i++) {
              this.editItem.saiken_file[i].saiken_upload_again_flg =
                this.commonService.exchange01toTF(
                  this.editItem.saiken_file[i].saiken_upload_again_flg,
                );
            }
            for (let i = 0; i < this.editItem.upload_file.length; i++) {
              this.editItem.upload_file[i].upload_again_flg =
                this.commonService.exchange01toTF(
                  this.editItem.upload_file[i].upload_again_flg,
                );
            }
            this.editItem.history = res["fuel_results"];
          } else if (res["fuel_status"] == "NG") {
            this.commonService.modalOpens(
              res["fuel_message"],
              (modalresult) => {},
            );
          } else {
            this.commonService.modalOpens(11003, (modalresult) => {});
          }
        },
        (error) => {
          this.commonService.modalOpens(error, (modalresult) => {});
        },
      );
    }
  }

  calcage(): void {
    var year = this.editItem.birthday.year;
    var month = this.editItem.birthday.month;
    var day = this.editItem.birthday.day;

    var birthdate = year * 10000 + month * 100 + day;
    var today = new Date();
    var targetdate =
      today.getFullYear() * 10000 +
      (today.getMonth() + 1) * 100 +
      today.getDate();
    this.editItem.age = Math.floor((targetdate - birthdate) / 10000);
  }

  save(): void {
    this.commonService.modalOpens(
      50001,
      //保存してもよろしいですか？
      async (modalresult) => {
        if (modalresult == "OK") {
          this.editItem.birthday = this.commonService.exchangeDateFormat2(
            this.editItem.birthday,
          );
          this.editItem.examination_target_flg =
            this.commonService.exchangeTFto01(
              this.editItem.examination_target_flg,
            );
          // this.editItem.mail = this.editItem.mail.replace(/\s+/g, "");  現状、空白エラーが機能しているためコメントアウト

          for (let i = 0; i < this.editItem.upload_file.length; i++) {
            this.editItem.upload_file[i].upload_again_flg =
              this.commonService.exchangeTFto01(
                this.editItem.upload_file[i].upload_again_flg,
              );
          }

          // PDFの結合処理
          for (let i = 0; i < this.editItem.saiken_file.length; i++) {
            this.editItem.saiken_file[i].saiken_upload_again_flg =
              this.commonService.exchangeTFto01(
                this.editItem.saiken_file[i].saiken_upload_again_flg,
              );
            const buffers: ArrayBuffer[] = [];
            for (const file of this.editItem.saiken_file[i].up_file) {
              const buffer = await this.pdfService.readAsArrayBuffer(file);
              buffers.push(buffer);
            }
            const merged = await this.pdfService.mergePdfs(buffers);
            const safeBytes = new Uint8Array(merged.length);
            safeBytes.set(merged);
            const uploadFile = new File([safeBytes], "upload.pdf", {
              type: "application/pdf",
            });
            this.editItem.saiken_file[i].up_file_base_64 =
              await this.pdfService.fileToBase64(uploadFile);
          }

          // ファイルアップロード機能（管理者）マイナビ202607 start
          // 関連ファイルのうち、選択されたPDFだけを保存用データに変換する
          await this.preparePdfFiles(this.editItem.kanren_file);
          // ファイルアップロード機能（管理者）マイナビ202607 end

          this.personService.save(this.editItem).subscribe(
            (res: Response) => {
              if (res["fuel_status"] == "OK") {
                this.commonService.modalOpens(10001, (modalresult) => {
                  if (modalresult == "OK") {
                    this.editItem.t_person_id = null;
                    this.selected = false;
                    this.searchPerson();
                  }
                });
              } else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(
                  res["fuel_message"],
                  (modalresult) => {},
                );
              } else {
                this.commonService.modalOpens(11003, (modalresult) => {});
              }
            },
            (error) => {
              this.commonService.modalOpens(error, (modalresult) => {});
            },
          );
        } else {
          //
        }
      },
    );
  }
  pw_reset(): void {
    this.commonService.modalOpens(
      50011,
      //パスワード初期化してもよろしいですか？
      (modalresult) => {
        if (modalresult == "OK") {
          this.usersService.resetPassword(this.editItem).subscribe(
            (res: Response) => {
              if (res["fuel_status"] == "OK") {
                this.commonService.modalOpens(10006, (modalresult) => {
                  //
                });
              } else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(
                  res["fuel_message"],
                  (modalresult) => {},
                );
              } else {
                this.commonService.modalOpens(11003, (modalresult) => {});
              }
            },
            (error) => {
              this.commonService.modalOpens(error, (modalresult) => {});
            },
          );
        } else {
          //
        }
      },
    );
  }
  cancel(): void {
    this.commonService.modalOpens(
      50005,
      //編集中の内容を破棄してもよろしいですか？
      (modalresult) => {
        if (modalresult == "OK") {
          this.editItem.t_person_id = null;
          this.selected = false;
        } else {
        }
      },
    );
  }
  delete(): void {
    this.commonService.modalOpens(
      50002,
      //削除してもよろしいですか？
      (modalresult) => {
        if (modalresult == "OK") {
          this.personService.delete(this.editItem).subscribe(
            (res: Response) => {
              if (res["fuel_status"] == "OK") {
                this.commonService.modalOpens(10002, (modalresult) => {
                  this.selectedList = this.selectedList.filter(
                    (item) => item.t_person_id != this.editItem.t_person_id,
                  );
                  this.selected = false;
                  this.searchPerson();
                });
              } else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(
                  res["fuel_message"],
                  (modalresult) => {},
                );
              } else {
                this.commonService.modalOpens(11003, (modalresult) => {});
              }
            },
            (error) => {
              this.commonService.modalOpens(error, (modalresult) => {});
            },
          );
        } else {
          //
        }
      },
    );
  }
  //■■■取り込んだCSVの削除■■■//
  delpersons(row: any): void {
    this.commonService.modalOpens(
      50002,
      //削除してもよろしいですか？
      (modalresult) => {
        if (modalresult == "OK") {
          this.personService.delpersons(row).subscribe(
            (res: Response) => {
              if (res["fuel_status"] == "OK") {
                this.commonService.modalOpens(10002, (modalresult) => {
                  this.selected = false;
                  this.searchPerson();
                });
              } else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(
                  res["fuel_message"],
                  (modalresult) => {},
                );
              } else {
                this.commonService.modalOpens(11003, (modalresult) => {});
              }
            },
            (error) => {
              this.commonService.modalOpens(error, (modalresult) => {});
            },
          );
        } else {
          //
        }
      },
    );
  }
  checkList(): boolean {
    if (this.editItem.name == "") {
      return true;
    }
    if (this.editItem.m_gender_id == "9") {
      return true;
    }
    if (
      this.editItem.mail == "" ||
      this.editItem.mail.match(
        /^[\w\d_¥!#$%&'*+/=?^`{|}~\\-]+([.]?[\w\d_¥!#$%&'*+/=?^`{|}~¥\\-])*[\w\d_¥!#$%&'*+/=?^`{|}~¥\\-]*@[\w\d_¥!#$%&'*+/=?^`{|}~¥\\-]+(?:\.[\w\d_¥!#$%&'*+/=?^`{|}~¥\\-]+)+$/,
      )
    ) {
      return false;
    }
    for (let key in this.editItem) {
      if (this.editItem[key] == "null") {
        return true;
      }
    }
    return false;
  }
  searchPerson(): void {
    this.page = 1;

    let checkedCategoryList = [];
    let cateList = this.search.question_category;
    for (let cate in cateList) {
      let checkStatusList = [];
      let stList = cateList[cate]["answerstatuslist"];

      for (let st in stList) {
        if (stList[st]["status_check"]) {
          checkStatusList.push(parseInt(stList[st]["id"]));
        }
      }
      if (checkStatusList.length > 0) {
        let param = {
          category_id: cateList[cate]["t_question_category_id"],
          select_status_list: checkStatusList,
        };
        checkedCategoryList.push(param);
      }
    }

    // 予約日検索の配列を作成
    this.search_yoyaku_date = [];
    if (this.search["yoyakuhyo"]) {
      if (this.search.yoyakuhyo.length > 0) {
        var tmp = { id: null, yoyaku_date: null };
        for (let i = 0; this.search.yoyakuhyo.length > i; i++) {
          tmp = {
            id: this.search.yoyakuhyo[i].m_yoyakuhyo_id,
            yoyaku_date: null,
          };
          tmp.yoyaku_date = this.search.yoyakuhyo[i].search_yoyaku_date;
          if (tmp.yoyaku_date != null && tmp.yoyaku_date != "") {
            this.search_yoyaku_date.push(tmp);
          }
        }
      }
    }

    //予約用に処理を追加
    let checkedyoyakuhyoList = [];
    let cateListYoyaku = this.search.yoyakuhyo;
    for (let cate in cateListYoyaku) {
      let checkStatusList = [];
      let stList = cateListYoyaku[cate]["yoyakustatuslist"];

      for (let st in stList) {
        if (stList[st]["status_check"]) {
          checkStatusList.push(parseInt(stList[st]["id"]));
        }
      }
      if (checkStatusList.length > 0) {
        let param = {
          category_id: cateListYoyaku[cate]["t_yoyakuhyo_id"],
          select_status_list: checkStatusList,
          search_yoyaku_date: cateListYoyaku[cate]["search_yoyaku_date"],
        };
        checkedyoyakuhyoList.push(param);
      }
    }

    //checkedCategoryListが空の場合は必ずデータ件数は0件

    if (checkedCategoryList.length == 0 && cateList != null) {
      if (cateList.length == 0) {
        //問診を紐づけていない場合はカテゴリでの検索はできないので
        checkedCategoryList = null;
      } else {
        this.datalist = [];
        return;
      }
    }
    //DBアクセス前に1度データをクリア(searchとeditは消さない)
    this.clearData();

    //回答の配列を作り直す 2019/10/11
    var s_answer_list = [];
    var s_tqc_id = [];

    this.examination_target_flg = this.commonService.exchangeTFto01(
      this.examination_target_flg,
    );
    this.upload_required_flg = this.commonService.exchangeTFto01(
      this.upload_required_flg,
    );

    s_answer_list = this.search_answer_list.filter((item) => item != null);
    s_tqc_id = this.search_tqc_id.filter((item) => item != null);

    let params = {
      event_id: this.selected_event_id,
      tp_code: this.inputCode,
      tp_name: this.inputName,
      tc_id: this.inputCompany != "null" ? this.inputCompany : null,
      ts_name: this.inputSyozoku,
      cate_list: checkedCategoryList,
      selected_category: this.selectedCategory,
      page: this.page,
      display_per_page: this.display_per_page,
      tqc_id: s_tqc_id,
      search_answer_list: s_answer_list,
      mode: this.search_answer_mode,
      cate_list_yoyaku: checkedyoyakuhyoList,
      search_yoyaku_date: this.search_yoyaku_date,
      yoyaku_date_sort: this.yoyaku_sort,
      mendan_from: this.inputMendandayFrom,
      mendan_to: this.inputMendandayTo,
      hiro_id: this.inputHiro,
      suimin_id: this.inputSuimin,
      mendan_user_id: this.inputInterviewer,
      t_upload_maintenance_id: this.selectedUploadStr,
      examination_target_flg: this.examination_target_flg,
      upload_required_flg: this.upload_required_flg,
      reinspection_unuploaded_flg: this.commonService.exchangeTFto01(
        this.reinspectionUnuploadedFlg,
      ),
      saiken_upload_flg: this.saikenUploadFlg,
    };

    this.personService.getPersonSearch(params).subscribe(
      (res: Response) => {
        if (res["fuel_status"] == "OK") {
          this.event = res["fuel_results"]["event"];
          if (this.event.length == 0) {
            //対象のイベントがないメッセージを表示し、イベント一覧画面へ飛ばす
            this.commonService.modalOpens(11007, (modalresult) => {
              this.router.navigate(["/event"]);
            });
          }
          this.mendan_flg = res["fuel_results"]["option_mendan_flg"];
          this.online_flg = res["fuel_results"]["online_flg"];
          this.mendan_ishi_flg = res["fuel_results"]["mendan_ishi_flg"];
          this.upload_flg = res["fuel_results"]["upload_flg"];
          this.all_count = res["fuel_results"]["all_count"];
          this.all_datalist = res["fuel_results"]["person"];
          this.hiro_list = res["fuel_results"]["hiro_list"][0];
          this.changePage(1);

          this.language_list = res["fuel_results"]["language_list"];
          this.import_language_id = this.language_list[0]["id"];
          this.import_history_list = res["fuel_results"]["import_history"];

          this.output_history_list = res["fuel_results"]["output_history"];

          //searchとeditは初回の値を使い続ける
          if (this.search.length == 0) {
            this.search = res["fuel_results"]["search"];
            let cateList = this.search.question_category;
            for (let cate in cateList) {
              if (cateList[cate]["previous_t_event_id"] == null) {
                cateList[cate]["previous_t_event_ids"] = [];
              } else {
                cateList[cate]["previous_t_event_ids"] =
                  cateList[cate]["previous_t_event_id"].split(",");
              }
            }
            // 出力ボタンの活性制御 => class_idが存在する問診があれば活性とする
            this.canOutputFlg =
              cateList.filter((item) => item.class_id != null).length > 0;
            this.edit = res["fuel_results"]["edit"];
            // 予約表の日付条件を配列化
            if (this.search.yoyakuhyo.length > 0) {
              for (
                let index = 0;
                this.search.yoyakuhyo.length > index;
                index++
              ) {
                this.search.yoyakuhyo[index].search_yoyaku_date = null;
              }
            }
          }

          this.isLoaded = true;

          //検索条件が入っている状態の時には検索窓を開く
          if (
            this.inputCode != null ||
            this.inputName != null ||
            this.inputCompany != null ||
            this.inputSyozoku ||
            this.selectedCategory != null
          ) {
            if (this.selectedCategory != null) {
              let cateList = this.search.question_category;
              for (let cate in cateList) {
                let row = this.selectedCategory.filter(
                  (item) => item == cateList[cate]["t_question_category_id"],
                );
                if (row.length == 0) {
                  this.cateCheckChange(cateList[cate]);
                }
                if (cateList[cate]["previous_t_event_id"] == null) {
                  cateList[cate]["previous_t_event_ids"] = [];
                } else {
                  cateList[cate]["previous_t_event_ids"] =
                    cateList[cate]["previous_t_event_id"].split(",");
                }
              }
              this.selectedCategory = null;
            }
          }
        } else if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(
            res["fuel_message"],
            (modalresult) => {},
          );
        } else {
          this.commonService.modalOpens(11003, (modalresult) => {});
        }
      },
      (error) => {
        this.commonService.modalOpens(error, (modalresult) => {});
      },
    );
  }

  preview(row: any): void {
    if (this.selected) {
      this.commonService.modalOpens(
        50005,
        //編集中の内容を破棄してもよろしいですか？
        (modalresult) => {
          if (modalresult == "OK") {
            this.shareService.refleshAll();
            this.shareService.setCategoryInfoShare({
              t_person_id: row.t_person_id,
              t_event_id: row.t_event_id,
              t_question_category_id: row.t_question_category_id,
              m_question_category_id: row.m_question_category_id,
              m_language_id: row.m_language_id,
            });
            this.shareService.setModeShare(2);
            this.getStartQuestionList(this.shareService.getCategoryInfoShare());
            // this.router.navigate(["/answer-preview"]);
          } else {
            return;
          }
        },
      );
    } else {
      this.shareService.refleshAll();
      this.shareService.setCategoryInfoShare({
        t_person_id: row.t_person_id,
        t_event_id: row.t_event_id,
        t_question_category_id: row.t_question_category_id,
        m_question_category_id: row.m_question_category_id,
        m_language_id: row.m_language_id,
      });
      this.shareService.setModeShare(2);
      this.getStartQuestionList(this.shareService.getCategoryInfoShare());
      // this.router.navigate(["/answer-preview"]);
    }
  }
  selectP(row) {
    if (row.selected) {
      if (this.checkSelectedList(row["t_person_id"])) {
      } else {
        this.selectedList.push(row);
      }
    } else {
      this.selectedList = this.selectedList.filter(
        (item) => item.t_person_id != row.t_person_id,
      );
    }
  }
  changePage(e) {
    var start = (e - 1) * this.display_per_page;
    this.datalist = this.all_datalist.slice(
      start,
      start + this.display_per_page,
    );
    for (let i = 0; i < this.datalist.length; i++) {
      if (this.checkSelectedList(this.datalist[i]["t_person_id"])) {
        this.datalist[i]["selected"] = true;
      } else {
        this.datalist[i]["selected"] = false;
      }
    }
  }

  //selectedListにt_person_idが含まれているか
  checkSelectedList(id: string): boolean {
    var row = this.selectedList.filter((item) => item.t_person_id === id);
    if (row.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  showerror(row): void {
    const modalRef = this.modalService.open(
      AViewTextModalComponent, //対象のComponent
      { backdrop: "static", keyboard: false, size: "lg" }, //オプション設定　Esc,背景クリックの時の処理…停止中
    );

    let sendlisttext: string = "";

    modalRef.componentInstance.view_title = "エラー";
    modalRef.componentInstance.view_text = row.import_result;
    modalRef.result.then(
      (result) => {
        if (result.status == "Cancel") {
          //Cancel時の処理
        } else {
        }
      },
      function () {
        // Esc,背景クリックの時の処理…オプション設定で停止中
      },
    );
  }

  selectedAllChange(): void {
    this.selectedList = [];
    this.person_all_select = !this.person_all_select;

    for (let row = 0; row < this.all_datalist.length; row++) {
      if (this.person_all_select) {
        this.selectedList.push(this.all_datalist[row]);
      }
      this.all_datalist[row]["selected"] = this.person_all_select;
    }

    // 画面のチェック済みの整合性を確保する
    for (let row = 0; row < this.datalist.length; row++) {
      this.datalist[row]["selected"] = this.person_all_select;
    }
  }

  selectedlistOpen(): void {
    const modalRef = this.modalService.open(
      AViewTextModalComponent, //対象のComponent
      { backdrop: "static", keyboard: false, size: "lg" }, //オプション設定　Esc,背景クリックの時の処理…停止中
    );

    let sendlisttext: string = "";

    modalRef.componentInstance.view_title = "選択リスト";
    sendlisttext = "全" + this.selectedList.length + "件<br>";
    for (let i = 0; i < this.selectedList.length; i++) {
      sendlisttext +=
        this.selectedList[i]["t_company_nm_short"] +
        "：" +
        this.selectedList[i]["name"];
      sendlisttext += " < " + this.selectedList[i]["mail"] + " > " + "<br>";
    }

    modalRef.componentInstance.view_text = sendlisttext;
    modalRef.result.then(
      (result) => {
        if (result.status == "Cancel") {
          //Cancel時の処理
        } else {
        }
      },
      function () {
        // Esc,背景クリックの時の処理…オプション設定で停止中
      },
    );
  }
  answerEdit(row: any): void {
    if (this.selected) {
      this.commonService.modalOpens(
        50005,
        //編集中の内容を破棄してもよろしいですか？
        (modalresult) => {
          if (modalresult == "OK") {
            this.shareService.refleshAll();
            this.shareService.setCategoryInfoShare({
              t_person_id: row.t_person_id,
              t_event_id: row.t_event_id,
              t_question_category_id: row.t_question_category_id,
              m_question_category_id: row.m_question_category_id,
              t_answer_status_id: row.t_answer_status_id,
              // m_language_id:row.m_language_id,
              m_language_id: this.language_list[0]["id"], //暫定的な処理(どの言語で画面を構成するか決定していない)
            });
            this.shareService.setModeShare(4); //EDITA

            this.getStartQuestionList(this.shareService.getCategoryInfoShare());
          } else {
            return;
          }
        },
      );
    } else {
      this.shareService.refleshAll();
      this.shareService.setCategoryInfoShare({
        t_person_id: row.t_person_id,
        t_event_id: row.t_event_id,
        t_question_category_id: row.t_question_category_id,
        m_question_category_id: row.m_question_category_id,
        t_answer_status_id: row.t_answer_status_id,
        // m_language_id:row.m_language_id,
        m_language_id: this.language_list[0]["id"], //暫定的な処理(どの言語で画面を構成するか決定していない)
      });
      this.shareService.setModeShare(4); //EDITA

      this.getStartQuestionList(this.shareService.getCategoryInfoShare());
    }
  }
  yoyakuEdit(row: any, personinfo: any): void {
    let p = {
      user_name: personinfo.name,
      contract_company_name: personinfo.m_contract_company_name,
      language_name: personinfo.m_language_name,
    };
    this.shareService.setAnswerUserInfo(p);

    if (this.selected) {
      this.commonService.modalOpens(
        50005,
        //編集中の内容を破棄してもよろしいですか？
        (modalresult) => {
          if (modalresult == "OK") {
            this.shareService.refleshAll();
            this.shareService.setCategoryInfoShare(row);
            this.shareService.setModeShare(4); //EDITA

            this.router.navigate(["/yoyaku-preview/main"]);
          } else {
            return;
          }
        },
      );
    } else {
      this.shareService.refleshAll();
      this.shareService.setCategoryInfoShare(row);
      this.shareService.setModeShare(4); //EDITA

      this.router.navigate(["/yoyaku-preview/main"]);
    }
  }
  //a0106メール配信(一人)
  goMail(row: any): void {
    if (this.selected) {
      this.commonService.modalOpens(
        50005,
        //編集中の内容を破棄してもよろしいですか？
        (modalresult) => {
          if (modalresult == "OK") {
            this.adminShareService.from_page = "person";
            this.adminShareService.temp_send_list = [];
            this.adminShareService.temp_send_list.push({
              id: row.t_person_id,
              t_company_id: row.t_company_id,
              company_name: row.t_company_name,
              company_nm_short: row.t_company_nm_short,
              t_syozoku_id: row.t_syozoku_id,
              syozoku_name: row.t_syozoku_name,
              syozoku_nm_short: row.t_syozoku_nm_short,
              code: row.code,
              name: row.name,
              mail: row.mail,
            });
            this.router.navigate(["/mail/" + this.selected_event_id]);
          } else {
            return;
          }
        },
      );
    } else {
      this.adminShareService.from_page = "person";
      this.adminShareService.temp_send_list = [];
      this.adminShareService.temp_send_list.push({
        id: row.t_person_id,
        t_company_id: row.t_company_id,
        company_name: row.t_company_name,
        company_nm_short: row.t_company_nm_short,
        t_syozoku_id: row.t_syozoku_id,
        syozoku_name: row.t_syozoku_name,
        syozoku_nm_short: row.t_syozoku_nm_short,
        code: row.code,
        name: row.name,
        mail: row.mail,
      });
      this.router.navigate(["/mail/" + this.selected_event_id]);
    }
  }

  //a0106メール配信(選択した人全員)
  goMailAll(): void {
    if (this.selected) {
      this.commonService.modalOpens(
        50005,
        //編集中の内容を破棄してもよろしいですか？
        (modalresult) => {
          if (modalresult == "OK") {
            this.adminShareService.from_page = "person";
            this.adminShareService.temp_send_list = [];
            for (let i in this.selectedList) {
              var row = this.selectedList[i];
              this.adminShareService.temp_send_list.push({
                id: row.t_person_id,
                t_company_id: row.t_company_id,
                company_name: row.t_company_name,
                company_nm_short: row.t_company_nm_short,
                t_syozoku_id: row.t_syozoku_id,
                syozoku_name: row.t_syozoku_name,
                syozoku_nm_short: row.t_syozoku_nm_short,
                code: row.code,
                name: row.name,
                mail: row.mail,
              });
            }
            this.router.navigate(["/mail/" + this.selected_event_id]);
          } else {
            return;
          }
        },
      );
    } else {
      this.adminShareService.from_page = "person";
      this.adminShareService.temp_send_list = [];
      for (let i in this.selectedList) {
        var row = this.selectedList[i];
        this.adminShareService.temp_send_list.push({
          id: row.t_person_id,
          t_company_id: row.t_company_id,
          company_name: row.t_company_name,
          company_nm_short: row.t_company_nm_short,
          t_syozoku_id: row.t_syozoku_id,
          syozoku_name: row.t_syozoku_name,
          syozoku_nm_short: row.t_syozoku_nm_short,
          code: row.code,
          name: row.name,
          mail: row.mail,
        });
      }
      this.router.navigate(["/mail/" + this.selected_event_id]);
    }
  }

  /**
   * 出力メソッド
   */
  goOutput(): void {
    const modalRef = this.modalService.open(
      AOutputModalComponent, //対象のComponent
      { backdrop: "static", keyboard: false, size: "lg" }, //オプション設定　Esc,背景クリックの時の処理…停止中
    );

    let sendlisttext: string = "";

    modalRef.componentInstance.view_title = "ファイル出力";
    modalRef.componentInstance.t_event_id = this.selected_event_id; //いらないかも
    modalRef.componentInstance.selected_person = this.selectedList;
    modalRef.componentInstance.output_language_id = this.output_language_id; //いらないかも
    modalRef.componentInstance.question_category =
      this.search.question_category.filter((item) => item.class_id != null);

    modalRef.result.then(
      (result) => {
        if (result.status == "Cancel") {
          //Cancel時の処理
        } else {
          //OK時の処理
          let param = {
            t_event_id: this.selected_event_id.toString(),
            m_language_id: this.output_language_id
              ? this.output_language_id.toString()
              : "",
            t_question_category_id: result.select_tqc_id.toString(),
            mode: result.mode.toString(),
            person_list: result.person_list,
            class_id: result.class_id,
            class_nm: result.class_nm,
          };

          // サーバーに送信
          this.commonService.modalOpens(10012, (modalresult) => {
            this.outputService.execOutput(param).subscribe((res: Response) => {
              if (res["fuel_status"] == "OK") {
              }
            });
          });
        }
      },
      function () {
        // Esc,背景クリックの時の処理…オプション設定で停止中
      },
    );
  }
  /**
   * 回答検索モーダルの起動
   */
  goAnswerSearch(cate: any, index: number): void {
    const modalRef = this.modalService.open(
      SearchAnswerModalComponent, //対象のComponent
      { backdrop: "static", keyboard: false, size: "lg" }, //オプション設定　Esc,背景クリックの時の処理…停止中
    );
    modalRef.componentInstance.question_category = cate;
    modalRef.componentInstance.selected = this.search_answer_list[index];

    modalRef.result.then(
      (result) => {
        if (result.status == "Cancel") {
          //Cancel時の処理
        } else {
          //OK時の処理
          if (result.answer_list != null) {
            this.search_tqc_id[index] = result.select_tqc_id;
            this.search_answer_list[index] = result.answer_list;
          } else if (this.search_answer_list.length > 0) {
            if (this.search_answer_list[index].length > 0) {
              this.search_tqc_id.splice(index, 1);
              this.search_answer_list.splice(index, 1);
            }
          }
        }
      },
      function () {
        // Esc,背景クリックの時の処理…オプション設定で停止中
      },
    );
  }
  // //回答検索モード 別質問の条件をAND・ORで切り替える
  // checkMode(){
  //     this.search_answer_mode = !this.search_answer_mode;
  // }
  /**
   * 1ファイルでのダウンロード処理
   * @param tqc t_question_categoryレコード＋α
   */
  goOutputSingle(tqc): void {
    // 確認ダイアル
    this.commonService.modalOpens(
      53001,
      //ファイルを出力しますか？
      (modalresult) => {
        if (modalresult == "OK") {
          //OK時の処理
          let param = {
            t_event_id: this.selected_event_id.toString(),
            m_language_id: this.output_language_id
              ? this.output_language_id.toString()
              : tqc.m_language_id.toString(),
            t_question_category_id: tqc.t_question_category_id.toString(),
            mode: "3",
            person_list: [tqc.t_person_id],
            class_id: tqc.class_id,
            class_nm: tqc.class_nm,
          };

          this.outputService
            .execOutputSingle(param)
            .subscribe((res: Response) => {
              if (res["fuel_status"] == "OK") {
                // download処理
                let downloadParam = {
                  t_output_history_id:
                    res["fuel_results"]["t_output_history_id"],
                };
                this.outputService.downloadFile(downloadParam);
              }
            });
        }
      },
    );
  }

  /**
   * ファイルダウンロード処理
   * @param row t_output_historyレコード
   */
  downloadFile(row): void {
    let param = {
      t_output_history_id: row.t_output_history_id,
    };
    this.outputService.checkExistsFile(param).subscribe((res: Response) => {
      if (res["fuel_status"] == "OK") {
        // download処理
        let downloadParam = {
          t_output_history_id: res["fuel_results"]["t_output_history_id"],
        };
        this.outputService.downloadFile(downloadParam);
      } else {
        this.commonService.modalOpens(res["fuel_message"], (modalresult) => {});
      }
    });
  }

  /**
   * 出力履歴の再取得
   */
  reloadOutput(): void {
    this.outputService.getOutputHistory(this.selected_event_id).subscribe(
      (res: Response) => {
        if (res["fuel_status"] == "OK") {
          this.output_history_list = res["fuel_results"]["output_history"];
        } else if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(
            res["fuel_message"],
            (modalresult) => {},
          );
        } else {
          this.commonService.modalOpens(11003, (modalresult) => {});
        }
      },
      (error) => {
        this.commonService.modalOpens(error, (modalresult) => {});
      },
    );
  }

  /**
   * 実行中に出力処理を中断するメソッド
   * @param row 出力歴レコード
   */
  cancelOutput(row): void {
    let param = {
      t_output_history_id: row.t_output_history_id,
    };
    // 確認メッセージをつけるべきか…
    this.commonService.modalOpens(
      54007,
      //ファイル出力をキャンセルしますか？
      (modalresult) => {
        if (modalresult == "OK") {
          this.outputService.cancelOutput(param).subscribe(
            (res: Response) => {
              if (res["fuel_status"] == "OK") {
                this.reloadOutput();
              } else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(
                  res["fuel_message"],
                  (modalresult) => {},
                );
              } else {
                this.commonService.modalOpens(11003, (modalresult) => {});
              }
            },
            (error) => {
              this.commonService.modalOpens(error, (modalresult) => {});
            },
          );
        } else {
          return;
        }
      },
    );
  }

  showErrorOutput(row): void {
    const modalRef = this.modalService.open(
      AViewTextModalComponent, //対象のComponent
      { backdrop: "static", keyboard: false, size: "lg" }, //オプション設定　Esc,背景クリックの時の処理…停止中
    );

    let sendlisttext: string = "";

    modalRef.componentInstance.view_title = "エラー";
    modalRef.componentInstance.view_text = row.output_result;
    modalRef.result.then(
      (result) => {
        if (result.status == "Cancel") {
          //Cancel時の処理
        } else {
        }
      },
      function () {
        // Esc,背景クリックの時の処理…オプション設定で停止中
      },
    );
  }

  /**
   * 予約メモ記入モーダルの起動
   */
  yoyakuMemo(yoyaku_data: any): void {
    const modalRef = this.modalService.open(
      AYoyakuMemoModalComponent, //対象のComponent
      { backdrop: "static", keyboard: false, size: "lg" }, //オプション設定　Esc,背景クリックの時の処理…停止中
    );
    modalRef.componentInstance.yoyaku_data = yoyaku_data;

    modalRef.result.then(
      (result) => {
        if (result.status == "Cancel") {
          //Cancel時の処理
        } else {
          //OK時の処理
          let param = {
            t_yoyaku_id: yoyaku_data.t_yoyaku_id,
            memo: result.yoyaku_memo,
            update_datetime: yoyaku_data.update_datetime,
          };
          this.yoyakuService.saveMemo(param).subscribe(
            (res: Response) => {
              if (res["fuel_status"] == "OK") {
                this.commonService.modalOpens(10001, (modalresult) => {
                  //reloadすると重いので対象レコードのみ差し替え
                  yoyaku_data.update_datetime =
                    res["fuel_results"]["update_datetime"];
                  yoyaku_data.yoyaku_memo = result.yoyaku_memo;
                });
              } else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(
                  res["fuel_message"],
                  (modalresult) => {},
                );
              } else {
                this.commonService.modalOpens(11003, (modalresult) => {});
              }
            },
            (error) => {
              this.commonService.modalOpens(error, (modalresult) => {});
            },
          );
        }
      },
      function () {
        // Esc,背景クリックの時の処理…オプション設定で停止中
      },
    );
  }
  //a0107状況確認
  goProgress(row: any): void {
    this.router.navigate(["/progress/" + row.id]);
  }

  fileSelect(file: any): void {
    // Edgeにて「取込」ボタンが活性状態にならないため処理を追加 2019/07/04
    this.selectInputFile = file;
  }

  refresh(): void {
    // 処理の中身がなかったため追加 2019/07/04
    this.selectInputFile = "";
  }
  reload(): void {
    this.personService.getImportHistory(this.selected_event_id).subscribe(
      (res: Response) => {
        if (res["fuel_status"] == "OK") {
          this.import_history_list = res["fuel_results"]["import_history"];
        } else if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(
            res["fuel_message"],
            (modalresult) => {},
          );
        } else {
          this.commonService.modalOpens(11003, (modalresult) => {});
        }
      },
      (error) => {
        this.commonService.modalOpens(error, (modalresult) => {});
      },
    );
  }
  selectedFile(file: File) {
    var userAgent = this.commonService.getUserAgent();
    if (userAgent == "Edge") {
      if (file === null || file === undefined) {
        this.file_selected = false;
      } else {
        this.file_selected = true;
      }
    } else {
      if (this.selectInputFile == "") {
        this.file_selected = false;
      } else {
        this.file_selected = true;
      }
    }
  }
  import(list: any): void {
    this.personService.importCheck().subscribe(
      (res: Response) => {
        if (res["fuel_status"] == "OK") {
          if (res["fuel_results"] == "1") {
            //処理中の時
            this.commonService.modalOpens(10011, (modalresult) => {});
          } else {
            this.commonService.modalOpens(
              54002,
              //取り込みますか？
              (modalresult) => {
                if (modalresult == "OK") {
                  let f = list[0];
                  // ファイルをセット
                  let data = new FormData();
                  data.append("upfile", f, f.name);
                  data.append("event_id", this.selected_event_id.toString());
                  data.append(
                    "language_id",
                    this.import_language_id.toString(),
                  );

                  // サーバーに送信
                  this.commonService.modalOpens(10010, (modalresult) => {
                    this.personService
                      .importPerson(data)
                      .subscribe((res: Response) => {
                        if (res["fuel_status"] == "OK") {
                          // 取込処理後に選択されているファイルをリフレッシュする 2019/07/04
                          this.refresh();
                        }
                      });
                  });

                  //.subscribe((res: Response) => {
                  // if (res["fuel_status"] == "OK") {
                  //     this.commonService.modalOpens(10004, modalresult => {
                  //         this.commonService.clear_file_Value('upfile');
                  //         this.search = [];
                  //         this.search_open = false;
                  //         this.searchInputClear();
                  //         this.searchPerson();
                  //     });
                  // } else if (res["fuel_status"] == "NG") {
                  //     this.commonService.modalOpens(res["fuel_message"], modalresult => {
                  //             this.personService.getImportHistory(this.selected_event_id)
                  //             .subscribe((res: Response) => {
                  //                 if (res["fuel_status"] == "OK") {
                  //                     this.import_history_list = res["fuel_results"]['import_history'];
                  //                 } else if (res["fuel_status"] == "NG") {
                  //                     this.commonService.modalOpens(res["fuel_message"], modalresult => { });
                  //                 } else {
                  //                     this.commonService.modalOpens(11003, modalresult => { });
                  //                 }
                  //             }, error => {
                  //                 this.commonService.modalOpens(error, modalresult => { });
                  //             });
                  //             //
                  //         });
                  // } else {
                  //     this.commonService.modalOpens(11003, modalresult => { });
                  // }
                  // }, error => {
                  //     this.commonService.modalOpens(error, modalresult => { });
                  // });
                } else {
                  //
                }
              },
            );
          }
        } else if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(
            res["fuel_message"],
            (modalresult) => {},
          );
        } else {
          this.commonService.modalOpens(11003, (modalresult) => {});
        }
      },
      (error) => {
        this.commonService.modalOpens(error, (modalresult) => {});
      },
    );
  }
  goBack(): void {
    if (this.selected) {
      this.commonService.modalOpens(
        50005,
        //編集中の内容を破棄してもよろしいですか？
        (modalresult) => {
          if (modalresult == "OK") {
            if (
              this.commonService.checkSamePageUrl(
                this.previousUrl,
                this.currentUrl,
              )
            ) {
              let aryP = this.previousUrl.split("/");
              let aryC = this.currentUrl.split("/");
              if (aryP[1] == aryC[1] && aryP[2] != aryC[2]) {
                this.goPerson(aryP[2]);
              } else {
                this.location.back();
              }
            } else {
              this.location.back();
            }
          } else {
            return;
          }
        },
      );
    } else {
      if (
        this.commonService.checkSamePageUrl(this.previousUrl, this.currentUrl)
      ) {
        let aryP = this.previousUrl.split("/");
        let aryC = this.currentUrl.split("/");
        if (aryP[1] == aryC[1] && aryP[2] != aryC[2]) {
          this.goPerson(aryP[2]);
        } else {
          this.location.back();
        }
      } else {
        this.location.back();
      }
    }
  }

  cateCheckChange(cate: any): void {
    cate["cate_check"] = !cate["cate_check"];
    for (let i in cate.answerstatuslist) {
      cate.answerstatuslist[i]["status_check"] = cate["cate_check"];
    }
  }

  cateCheckChangeYoyaku(cate: any): void {
    cate["cate_check"] = !cate["cate_check"];
    for (let i in cate.yoyakustatuslist) {
      cate.yoyakustatuslist[i]["status_check"] = cate["cate_check"];
    }
  }
  getStartQuestionList(categoryInfo): void {
    //全て表示フラグをfalseへ設定する
    let settingMonsinInfo = {
      has_SPError: false,
      chemical_alldisp: false,
      organic_alldisp: false,
    };

    //b0102と同じようにparamsを作成しGetに投げる処理の実装
    let params = {
      t_person_id: categoryInfo["t_person_id"],
      t_event_id: categoryInfo["t_event_id"],
      t_question_category_id: categoryInfo["t_question_category_id"],
      m_question_category_id: categoryInfo["m_question_category_id"],
      m_language_id: categoryInfo["m_language_id"],
    };

    this.monshinService.getStartQuestionList(params).subscribe(
      (res: Response) => {
        let startQuestionList = [];
        if (res["fuel_status"] == "OK") {
          //questionListが0レコードならエラー
          startQuestionList =
            res["fuel_results"]["question_list"] != null
              ? res["fuel_results"]["question_list"]
              : [];
          //特建過去がある場合、回答がなければNG
          for (let i in startQuestionList) {
            if (startQuestionList[i].m_question_type_id == "6") {
              //回答にhidden_flgがあれば、化学その他リストボタンをOPENしておく
              settingMonsinInfo.chemical_alldisp =
                this.shareService.checkSPPreviousError(startQuestionList[i]);
            } else if (startQuestionList[i].m_question_type_id == "7") {
              //回答にhidden_flgがあれば、有機その他リストボタンをOPENしておく
              settingMonsinInfo.organic_alldisp =
                this.shareService.checkSPPreviousError(startQuestionList[i]);
            }
            if (startQuestionList[i]["previous_flg"] == "1") {
              if (
                startQuestionList[i]["t_result_list"]["previous_result_id"] ==
                null
              ) {
                //過去回答参照で化学物質回答がない*プレビュー以外は進めない
                settingMonsinInfo.has_SPError = true;
              }
            }
          }
          this.shareService.setSettingMonsinInfo(settingMonsinInfo);

          let answerUserInfo =
            res["fuel_results"]["answerUserInfo"] != null
              ? res["fuel_results"]["answerUserInfo"]
              : null;
          this.shareService.setAnswerUserInfo(answerUserInfo);

          //質問データの保持
          this.shareService.setStartQuestionListShare(startQuestionList);
          this.shareService.setInitialStartQuestionListShare(
            JSON.parse(JSON.stringify(startQuestionList)),
          );
          if (startQuestionList.length > 0) {
            this.router.navigate(["/answer-preview/start"]);
          } else {
            //結果データを空で保持
            this.shareService.setStartResultListShare([]);

            this.router.navigate(["/answer-preview/main"]);
          }
        } else if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(
            res["fuel_message"],
            (modalresult) => {},
          );
        } else {
          this.commonService.modalOpens(11003, (modalresult) => {});
        }
      },
      (error) => {
        this.commonService.modalOpens(error, (modalresult) => {});
      },
    );
  }

  changeSelectCompany() {
    this.editItem.t_jigyoba_id = null;
    this.editItem.t_syokuba_id = null;
    this.editItem.t_syozoku_id = null;
    this.editItem.t_jigyosyo_id = null;
    this.editItem.t_yakusyoku_id = null;
    this.editItem.t_shikaku_id = null;
    this.editItem.t_syokusyu_id = null;
    this.editItem.t_mibun_id = null;
    this.editItem.t_course_id = null;
    this.editItem.mendan_from = null;
  }

  searchInputClear() {
    this.inputCode = null;
    this.inputName = null;
    this.inputCompany = null;
    this.inputSyozoku = null;
    this.inputMendandayFrom = null;
    this.inputMendandayTo = null;
    this.inputHiro = null;
    this.inputSuimin = null;
    this.inputInterviewer = null;
  }

  getCsvForGet() {
    this.commonService.modalOpens(
      54004,
      //回答を出力しますか？
      (modalresult) => {
        if (modalresult == "OK") {
          this.checkS = this.commonService.exchangeTFto01(this.SJIScheck);

          var s_answer_list = [];
          var s_tqc_id = [];
          var s_answer = false;

          s_answer_list = this.search_answer_list.filter(
            (item) => item != null,
          );
          s_tqc_id = this.search_tqc_id.filter((item) => item != null);
          if (s_answer_list.length > 0) {
            s_answer = true;
          }

          let params = {
            te_id: this.selected_event_id,
            tp_code: this.inputCode,
            tp_name: this.inputName,
            tc_id: this.inputCompany != "null" ? this.inputCompany : null,
            ts_name: this.inputSyozoku,
            cate_list: [],
            lang_id: this.import_language_id,
            file_name: "受診者",
            checkS: this.checkS,
            s_tqc_id: s_tqc_id,
            search_answer_list: s_answer_list,
            mode: this.search_answer_mode,
            s_answer: s_answer,
            mendan_from: this.inputMendandayFrom,
            mendan_to: this.inputMendandayTo,
            hiro_id: this.inputHiro,
            suimin_id: this.inputSuimin,
            mendan_interviewer_id: this.inputInterviewer,
          };
          this.personService.csvCheck(params).subscribe(
            (res: Response) => {
              let startQuestionList = [];
              if (res["fuel_status"] == "OK") {
                params = this.csvParamCheck(params);
                this.personService.createCsvForGet(params);
              } else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(
                  res["fuel_message"],
                  (modalresult) => {},
                );
              } else {
                this.commonService.modalOpens(11003, (modalresult) => {});
              }
            },
            (error) => {
              this.commonService.modalOpens(error, (modalresult) => {});
            },
          );
        } else {
          //
        }
      },
    );
  }

  getCsvCategory(category: any) {
    this.commonService.modalOpens(
      54003,
      //受検者一覧を出力しますか？
      (modalresult) => {
        if (modalresult == "OK") {
          this.checkS = this.commonService.exchangeTFto01(this.SJIScheck);

          var s_answer_list = [];
          var s_tqc_id = [];
          var s_answer = false;

          s_answer_list = this.search_answer_list.filter(
            (item) => item != null,
          );
          s_tqc_id = this.search_tqc_id.filter((item) => item != null);
          if (s_answer_list.length > 0) {
            s_answer = true;
          }

          let params = {
            te_id: this.selected_event_id,
            tp_code: this.inputCode,
            tp_name: this.inputName,
            tc_id: this.inputCompany != "null" ? this.inputCompany : null,
            ts_name: this.inputSyozoku,
            tqc_id: category["t_question_category_id"],
            mqc_id: category["m_question_category_id"],
            status_1:
              category["answerstatuslist"][0]["status_check"] === false
                ? null
                : 1, //型に注意
            status_2:
              category["answerstatuslist"][1]["status_check"] === false
                ? null
                : 2, //boolean型になるのは1度でも触ったとき
            status_3:
              category["answerstatuslist"][2]["status_check"] === false
                ? null
                : 3, //"true"||trueでないとダメ
            lang_id: this.import_language_id,
            checkS: this.checkS,
            type9_exist: category["question_type"][0]["type9_exist"],
            type9_type6_qc_id:
              category["question_type"][0]["type9_type6_qc_id"],
            type9_type7_qc_id:
              category["question_type"][0]["type9_type7_qc_id"],
            type9_type6_q_id: category["question_type"][0]["type9_type6_q_id"],
            type9_type7_q_id: category["question_type"][0]["type9_type7_q_id"],
            previous_t_event_id: category["previous_t_event_id"],
            s_tqc_id: s_tqc_id,
            search_answer_list: s_answer_list,
            mode: this.search_answer_mode,
            s_answer: s_answer,
            // 長時間追加
            mendan_from: this.inputMendandayFrom,
            mendan_to: this.inputMendandayTo,
            hiro_id: this.inputHiro,
            suimin_id: this.inputSuimin,
            mendan_interviewer_id: this.inputInterviewer,
            // "file_name": category["name"],
          };
          this.personService.csvCheck(params).subscribe(
            (res: Response) => {
              let startQuestionList = [];
              if (res["fuel_status"] == "OK") {
                params = this.csvParamCheck(params);
                this.personService.createCsvForGet(params);
              } else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(
                  res["fuel_message"],
                  (modalresult) => {},
                );
              } else {
                this.commonService.modalOpens(11003, (modalresult) => {});
              }
            },
            (error) => {
              this.commonService.modalOpens(error, (modalresult) => {});
            },
          );
        } else {
          //
        }
      },
    );
  }

  getCsvSpecific(category: any) {
    this.commonService.modalOpens(
      54005,
      //特定化学物質の使用リストを出力しますか？
      (modalresult) => {
        if (modalresult == "OK") {
          this.checkS = this.commonService.exchangeTFto01(this.SJIScheck);

          var s_answer_list = [];
          var s_tqc_id = [];
          var s_answer = false;

          s_answer_list = this.search_answer_list.filter(
            (item) => item != null,
          );
          s_tqc_id = this.search_tqc_id.filter((item) => item != null);
          if (s_answer_list.length > 0) {
            s_answer = true;
          }

          let params = {
            te_id: this.selected_event_id,
            tp_code: this.inputCode,
            tp_name: this.inputName,
            tc_id: this.inputCompany != "null" ? this.inputCompany : null,
            ts_name: this.inputSyozoku,
            tqc_id: category["t_question_category_id"],
            mqc_id: category["m_question_category_id"],
            status_1:
              category["answerstatuslist"][0]["status_check"] === false
                ? null
                : 1, //型に注意
            status_2:
              category["answerstatuslist"][1]["status_check"] === false
                ? null
                : 2, //boolean型になるのは1度でも触ったとき
            status_3:
              category["answerstatuslist"][2]["status_check"] === false
                ? null
                : 3, //"true"||trueでないとダメ
            lang_id: this.import_language_id,
            type6_exist: category["question_type"][0]["type6_exist"],
            checkS: this.checkS,
            s_tqc_id: s_tqc_id,
            search_answer_list: s_answer_list,
            mode: this.search_answer_mode,
            s_answer: s_answer,
            // "file_name": category["name"],
          };
          this.personService.csvCheck(params).subscribe(
            (res: Response) => {
              let startQuestionList = [];
              if (res["fuel_status"] == "OK") {
                params = this.csvParamCheck(params);
                this.personService.createCsvForGet(params);
              } else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(
                  res["fuel_message"],
                  (modalresult) => {},
                );
              } else {
                this.commonService.modalOpens(11003, (modalresult) => {});
              }
            },
            (error) => {
              this.commonService.modalOpens(error, (modalresult) => {});
            },
          );
        } else {
          //
        }
      },
    );
  }

  getCsvOrganic(category: any) {
    this.commonService.modalOpens(
      54006,
      //有機溶剤の使用リストを出力しますか？
      (modalresult) => {
        if (modalresult == "OK") {
          this.checkS = this.commonService.exchangeTFto01(this.SJIScheck);

          var s_answer_list = [];
          var s_tqc_id = [];
          var s_answer = false;

          s_answer_list = this.search_answer_list.filter(
            (item) => item != null,
          );
          s_tqc_id = this.search_tqc_id.filter((item) => item != null);
          if (s_answer_list.length > 0) {
            s_answer = true;
          }

          let params = {
            te_id: this.selected_event_id,
            tp_code: this.inputCode,
            tp_name: this.inputName,
            tc_id: this.inputCompany != "null" ? this.inputCompany : null,
            ts_name: this.inputSyozoku,
            tqc_id: category["t_question_category_id"],
            mqc_id: category["m_question_category_id"],
            status_1:
              category["answerstatuslist"][0]["status_check"] === false
                ? null
                : 1, //型に注意
            status_2:
              category["answerstatuslist"][1]["status_check"] === false
                ? null
                : 2, //boolean型になるのは1度でも触ったとき
            status_3:
              category["answerstatuslist"][2]["status_check"] === false
                ? null
                : 3, //"true"||trueでないとダメ
            lang_id: this.import_language_id,
            type7_exist: category["question_type"][0]["type7_exist"],
            checkS: this.checkS,
            s_tqc_id: s_tqc_id,
            search_answer_list: s_answer_list,
            mode: this.search_answer_mode,
            s_answer: s_answer,
            // "file_name": category["name"],
          };
          this.personService.csvCheck(params).subscribe(
            (res: Response) => {
              let startQuestionList = [];
              if (res["fuel_status"] == "OK") {
                params = this.csvParamCheck(params);
                this.personService.createCsvForGet(params);
              } else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(
                  res["fuel_message"],
                  (modalresult) => {},
                );
              } else {
                this.commonService.modalOpens(11003, (modalresult) => {});
              }
            },
            (error) => {
              this.commonService.modalOpens(error, (modalresult) => {});
            },
          );
        } else {
          //
        }
      },
    );
  }
  getCsvForYoyakuGet(category: any) {
    this.commonService.modalOpens(
      54004,
      //回答を出力しますか？
      (modalresult) => {
        if (modalresult == "OK") {
          this.checkS = this.commonService.exchangeTFto01(this.SJIScheck);

          let params = {
            te_id: this.selected_event_id,
            tp_code: this.inputCode,
            tp_name: this.inputName,
            tc_id: this.inputCompany != "null" ? this.inputCompany : null,
            ts_name: this.inputSyozoku,
            status_4:
              category["yoyakustatuslist"][0]["status_check"] === false
                ? null
                : 1, //型に注意
            status_5:
              category["yoyakustatuslist"][1]["status_check"] === false
                ? null
                : 2, //boolean型になるのは1度でも触ったとき
            status_6:
              category["yoyakustatuslist"][2]["status_check"] === false
                ? null
                : 3, //"true"||trueでないとダメ
            status_7:
              category["yoyakustatuslist"][3]["status_check"] === false
                ? null
                : 4,
            cate_list: [],
            lang_id: category["main_language_sort"],
            file_name: "予約",
            checkS: this.checkS,
            tyh_id: category["t_yoyakuhyo_id"],
            yoyakuhyo_nm: category["name"],
            search_yoyaku_date: category.search_yoyaku_date,
          };
          this.personService.csvCheck(params).subscribe(
            (res: Response) => {
              let startQuestionList = [];
              if (res["fuel_status"] == "OK") {
                params = this.csvParamCheck(params);
                this.personService.createCsvForGet(params);
              } else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(
                  res["fuel_message"],
                  (modalresult) => {},
                );
              } else {
                this.commonService.modalOpens(11003, (modalresult) => {});
              }
            },
            (error) => {
              this.commonService.modalOpens(error, (modalresult) => {});
            },
          );
        } else {
          //
        }
      },
    );
  }
  checkCategoryChecked(category: any) {
    return (
      category["answerstatuslist"][0]["status_check"] === false &&
      category["answerstatuslist"][1]["status_check"] === false &&
      category["answerstatuslist"][2]["status_check"] === false
    );
  }
  checkYoyakuChecked(category: any) {
    return (
      category["yoyakustatuslist"][0]["status_check"] === false &&
      category["yoyakustatuslist"][1]["status_check"] === false &&
      category["yoyakustatuslist"][2]["status_check"] === false &&
      category["yoyakustatuslist"][3]["status_check"] === false
    );
  }
  csvParamCheck(params: any) {
    delete params.s_tqc_id;
    delete params.search_answer_list;
    delete params.mode;
    return params;
  }
  goPerson(eid: any) {
    this.clearSearch();
    this.selected_event_id = eid;
    this.router.navigate(["/person/" + eid]);

    this.searchPerson();
  }
  goPersonbycode(eid: any, code: string) {
    this.clearSearch();
    this.selected_event_id = eid;
    this.router.navigate(["/person/" + eid]);
    //特定の人を当てるためにコードを指定する
    this.inputCode = code;
    this.searchPerson();
  }

  goAnalysis(category: any) {
    this.router.navigate([
      "/result-analysis/" +
        category["t_question_category_id"] +
        "/" +
        this.import_language_id,
    ]);
  }

  goYoyakuhyo(category: any) {
    this.router.navigate(["/yoyaku-list/" + category["m_yoyakuhyo_id"]]);
  }

  clearSearch() {
    this.page = 1;
    this.all_count = 0;

    this.selected = false;
    this.datalist = [];
    this.all_datalist = [];
    this.selectedList = [];

    //Form
    this.searchInputClear();

    //編集フォーム
    this.search = [];
    this.edit = [];
    this.editItem = [];

    this.selectedCategory = null;

    this.event = [];

    this.language_list = [];
    this.import_language_id = null;
    this.import_history_list = [];

    this.output_language_id = null;
    this.output_history_list = [];

    this.isLoaded = false;
  }

  //受付する
  yoyakuAccept(yoyakuInfo) {
    //受付してもよろしいですか？を表示し、OKなら受付する
    this.commonService.modalOpens(
      50018,
      //受付してもよろしいですか？
      (modalresult) => {
        if (modalresult == "OK") {
          //受付処理
          this.yoyakuService.acceptYoyaku(yoyakuInfo).subscribe(
            (res: Response) => {
              if (res["fuel_status"] == "OK") {
                this.commonService.modalOpens(10014, (modalresult) => {
                  if (modalresult == "OK") {
                    //reloadすると重いので対象レコードのみ差し替え
                    yoyakuInfo.update_datetime =
                      res["fuel_results"]["update_datetime"];
                    yoyakuInfo.yoyaku_status_id = 3;
                    yoyakuInfo.m_yoyaku_status_name = "受付済";
                    yoyakuInfo.reception_flg = 1;
                    yoyakuInfo.reception_datetime =
                      res["fuel_results"]["update_datetime"];
                  }
                });
              } else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(
                  res["fuel_message"],
                  (modalresult) => {},
                );
              } else {
                this.commonService.modalOpens(11003, (modalresult) => {});
              }
            },
            (error) => {
              this.commonService.modalOpens(error, (modalresult) => {});
            },
          );
        } else {
          //
        }
      },
    );
  }

  // 予約キャンセル
  yoyakuCancel(yoyakuInfo) {
    //キャンセルしてもよろしいですか？を表示し、OKなら取消する
    this.commonService.modalOpens(
      50017,
      //キャンセルしてもよろしいですか？
      (modalresult) => {
        if (modalresult == "OK") {
          //取消処理
          yoyakuInfo["online_flg"] = this.online_flg;
          this.yoyakuService.cancelYoyaku(yoyakuInfo).subscribe(
            (res: Response) => {
              if (res["fuel_status"] == "OK") {
                this.commonService.modalOpens(10013, (modalresult) => {
                  if (modalresult == "OK") {
                    let mode = res["fuel_results"]["mode"];
                    yoyakuInfo.mode = mode;
                    this.mailService
                      .send(yoyakuInfo)
                      .subscribe((res: Response) => {
                        if (res["fuel_status"] == "OK") {
                        }
                      });
                    //reloadすると重いので対象レコードのみ差し替え
                    yoyakuInfo.update_datetime =
                      res["fuel_results"]["update_datetime"];
                    yoyakuInfo.yoyaku_status_id = 1;
                    yoyakuInfo.m_yoyaku_status_name = "未予約";
                    yoyakuInfo.yoyaku_date = "";
                    yoyakuInfo.m_timeaxis_name = "";
                    yoyakuInfo.m_division_1_name = "";
                    yoyakuInfo.m_division_2_name = "";
                  }
                });
              } else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(
                  res["fuel_message"],
                  (modalresult) => {},
                );
              } else {
                this.commonService.modalOpens(11003, (modalresult) => {});
              }
            },
            (error) => {
              this.commonService.modalOpens(error, (modalresult) => {});
            },
          );
        } else {
          //
        }
      },
    );
  }
  //受付の取り消し
  yoyakuAcceptCancel(yoyakuInfo) {
    //受付状態のキャンセルを行ってもよろしいですか？を表示し、OKなら受付する
    this.commonService.modalOpens(
      50020,
      //受付状態のキャンセルを行ってもよろしいですか？
      (modalresult) => {
        if (modalresult == "OK") {
          //受付処理取り消し
          this.yoyakuService.acceptYoyakuCancel(yoyakuInfo).subscribe(
            (res: Response) => {
              if (res["fuel_status"] == "OK") {
                this.commonService.modalOpens(10013, (modalresult) => {
                  if (modalresult == "OK") {
                    // キャンセルの場合のみreloadする
                    this.searchPerson();
                  }
                });
              } else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(
                  res["fuel_message"],
                  (modalresult) => {},
                );
              } else {
                this.commonService.modalOpens(11003, (modalresult) => {});
              }
            },
            (error) => {
              this.commonService.modalOpens(error, (modalresult) => {});
            },
          );
        } else {
          //
        }
      },
    );
  }
  goYoyakuDateSearch(index: number): void {
    const modalRef = this.modalService.open(
      SearchYoyakuDayModelComponent, //対象のComponent
      { backdrop: "static", keyboard: false, size: "sm" }, //オプション設定　Esc,背景クリックの時の処理…停止中
    );
    modalRef.componentInstance.searchYoyakuDate =
      this.search.yoyakuhyo[index].search_yoyaku_date;
    modalRef.result.then(
      (result) => {
        if (result.status == "OK") {
          this.search.yoyakuhyo[index].search_yoyaku_date = result.selectedData;
        } else {
          //
        }
      },
      function () {
        // Esc,背景クリックの時の処理…オプション設定で停止中
      },
    );
  }
  memoCheck(data: any): boolean {
    if (data.yoyaku_memo == null || data.yoyaku_memo == "") {
      return false;
    } else {
      return true;
    }
  }
  yoyakuSort(): void {
    this.yoyaku_sort = this.yoyaku_sort + 1;
    if (this.yoyaku_sort > 2) {
      this.yoyaku_sort = 0;
    }
    this.searchPerson();
  }
  yoyakuProperty(data: any): void {
    const modalRef = this.modalService.open(
      YoyakuPropertyModelComponent, //対象のComponent
      { backdrop: "static", keyboard: false, size: "lg" }, //オプション設定　Esc,背景クリックの時の処理…停止中
    );
    modalRef.componentInstance.yoyakuData = data;
    modalRef.result.then(
      (result) => {
        if (result.status == "OK") {
        } else {
          //
        }
      },
      function () {
        // Esc,背景クリックの時の処理…オプション設定で停止中
      },
    );
  }
  changeJigyoba(): void {}
  changeSyokuba(): void {}
  changeJigyosyo(): void {}
  testchange(id): void {
    let test = this.yoyakuhyo_list.filter((item) => item.id == id);
    this.division_list = test[0].division_list;
    this.import_division_id = null;
  }

  toggleDate(selectDp: NgbInputDatepicker): void {
    selectDp.toggle();
  }

  open(content: any, t_person_id: number) {
    this.hitstory_data = [];
    let param = {
      t_person_id: t_person_id,
    };
    this.personService.getPersonpastHistoryReference(param).subscribe(
      (res: Response) => {
        if (res["fuel_status"] == "OK") {
          this.hitstory_data = res["fuel_results"]["person"];
          this.modalService
            .open(content, { windowClass: "CustomModalLl" })
            .result.then(
              (result) => {
                this.hitstory_data = [];
              },
              (reason) => {
                let closeResult = `Dismissed ${this.getDismissReason(reason)}`;
              },
            );
        } else if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(
            res["fuel_message"],
            (modalresult) => {},
          );
        } else {
          this.commonService.modalOpens(11003, (modalresult) => {});
        }
        this.is_loaded = true;
      },
      (error) => {
        this.commonService.modalOpens(error, (modalresult) => {});
        this.is_loaded = true;
      },
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  teamsUrlSend(param: any) {
    this.commonService.modalOpens(10901, (modalresult) => {
      if (modalresult == "OK") {
        this.mailService.sendTeamsUrl(param).subscribe(
          (res: Response) => {
            let questionList = [];
            if (res["fuel_status"] == "OK") {
              this.commonService.modalOpens(10005, (modalresult) => {});
            } else {
              this.commonService.modalOpens(11003, (modalresult) => {});
            }
          },
          (error) => {
            this.commonService.modalOpens(error, (modalresult) => {});
          },
        );
      } else {
        return;
      }
    });
  }

  teamsUrlCopy(yoyaku_id: any) {
    this.personService.postTeamsUrl(yoyaku_id).subscribe((res: Response) => {
      const COPY_BT = document.getElementById("accept_" + yoyaku_id);
      let URL_TEXT = res["fuel_results"]["teams_url"];

      (navigator as any).clipboard.writeText(URL_TEXT);
      COPY_BT.classList.add("copy_bt_complete");
      setTimeout(() => {
        COPY_BT.classList.remove("copy_bt_complete");
      }, 3500);
    });
  }

  objectCheck(obj: any, key: string): boolean {
    if (!(Object.keys(obj).indexOf(key) !== -1)) {
      return false;
    }
    if (obj[key].length == 0) {
      return false;
    }
    return true;
  }

  getCsvForMendanYoyakuGet(category: any) {
    this.commonService.modalOpens(
      54004,
      //回答を出力しますか？
      (modalresult) => {
        if (modalresult == "OK") {
          this.checkS = this.commonService.exchangeTFto01(this.SJIScheck);

          let params = {
            te_id: this.selected_event_id,
            tp_code: this.inputCode,
            tp_name: this.inputName,
            tc_id: this.inputCompany != "null" ? this.inputCompany : null,
            ts_name: this.inputSyozoku,
            status_4:
              category["yoyakustatuslist"][0]["status_check"] === false
                ? null
                : 1, //型に注意
            status_5:
              category["yoyakustatuslist"][1]["status_check"] === false
                ? null
                : 2, //boolean型になるのは1度でも触ったとき
            status_6:
              category["yoyakustatuslist"][2]["status_check"] === false
                ? null
                : 3, //"true"||trueでないとダメ
            status_7:
              category["yoyakustatuslist"][3]["status_check"] === false
                ? null
                : 4,
            cate_list: [],
            lang_id: category["main_language_sort"],
            file_name: "予約",
            checkS: this.checkS,
            tyh_id: category["t_yoyakuhyo_id"],
            yoyakuhyo_nm: category["name"],
            search_yoyaku_date: category.search_yoyaku_date,
          };
          this.personService.csvCheck(params).subscribe(
            (res: Response) => {
              let startQuestionList = [];
              if (res["fuel_status"] == "OK") {
                params = this.csvParamCheck(params);
                this.personService.createMendanCsvForGet(params);
              } else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(
                  res["fuel_message"],
                  (modalresult) => {},
                );
              } else {
                this.commonService.modalOpens(11003, (modalresult) => {});
              }
            },
            (error) => {
              this.commonService.modalOpens(error, (modalresult) => {});
            },
          );
        } else {
          //
        }
      },
    );
  }

  importSaiken(list: any): void {
    this.commonService.modalOpens(
      54002,
      //取り込みますか？
      (modalresult) => {
        if (modalresult == "OK") {
          const f = list[0];
          // ファイルをセット
          const fd = new FormData();
          fd.append("upfile", f, f.name);
          fd.append("t_event_id", this.selected_event_id.toString());
          this.fileUploadService.importSaiken(fd).subscribe((res: Response) => {
            if (res["fuel_status"] == "OK") {
            }
          });
        } else {
          //
        }
      },
    );
  }

  selectedUpload: number[] = [];
  selectedUploadStr: string = "";

  selectUM(item: any) {
    if (item.checked) {
      // チェックされた → 追加
      if (!this.selectedUpload.includes(item["t_upload_maintenance_id"])) {
        this.selectedUpload.push(item["t_upload_maintenance_id"]);
      }
    } else {
      // チェック外された → 削除
      this.selectedUpload = this.selectedUpload.filter(
        (id) => id !== item["t_upload_maintenance_id"],
      );
    }

    // カンマ区切り文字列を生成
    this.selectedUploadStr = this.selectedUpload.join(",");
  }

  /**
   * プレビューモーダル
   * @async
   */
  async openPreview(data: any) {
    const previewUrl = await this.pdfService.getPreviewPdfUrl(data.up_file);
    this.pdfService.pdfPreviewModalOpen(previewUrl, false, (modalresult) => {});

    // サーバーに保管されているデータを表示するコード
    // if (data.t_saiken_file_id == null) {
    //   return;
    // }
    // this.fileUploadService.getSaikenFileBinary(data.t_saiken_file_id).subscribe(
    //   async (res: Response) => {
    //     if (res["fuel_status"] == "OK") {
    //       let pdf = [];
    //       pdf.push(
    //         this.pdfService.base64ToFile(
    //           res["fuel_results"]["data"],
    //           "download",
    //           "application/pdf"
    //         )
    //       );
    //       const previewUrl = await this.pdfService.getPreviewPdfUrl(pdf);
    //       this.pdfService.pdfPreviewModalOpen(
    //         previewUrl,
    //         false,
    //         (modalresult) => {}
    //       );
    //     } else {
    //       this.commonService.modalOpens(11003, (modalresult) => {});
    //     }
    //   },
    //   (error) => {
    //     this.commonService.modalOpens(error, (modalresult) => {});
    //   }
    // );
  }

  /**
   * PDF選択時の処理
   * @param {event} any     ファイル選択イベント
   * @param {index} number  再検査ファイルデータのインデックス
   * @returns
   */
  public async onSaikenFilesSelected(event: any, index: number) {
    const files = event.target.files;
    for (let i = 0; i < files.length; i++) {
      const f = files[i];
      if (f.type === "application/pdf") {
        this.editItem.saiken_file[index].up_file.push(f);
      }
    }
  }

  /** ▼ 削除 */
  removeSaikenFile(index: number) {
    // this.editItem.saiken_file.splice(index, 1);
    this.editItem.saiken_file[index].delete_flg = 1;
  }

  //マイナビアップロードダウンロード(選択した人全員)
  downloadAll(category): void {
    if (this.selected) {
      this.commonService.modalOpens(
        50005,
        //編集中の内容を破棄してもよろしいですか？
        (modalresult) => {
          if (modalresult == "OK") {
            let person_list = [];
            for (let i in this.selectedList) {
              var row = this.selectedList[i];
              person_list.push({
                id: row.t_person_id,
                name: row.name,
                code: row.code,
                t_event_id: this.selected_event_id,
                t_question_category_id: category[0]["t_question_category_id"],
                differencial_download: this.commonService.exchangeTFto01(
                  this.differencialDownload,
                ),
              });
            }
            this.uploadService.DownloadUploadFile(person_list).subscribe(
              (res: any) => {
                if (res["fuel_status"] == "OK") {
                  this.selected = false;
                }
              },
              (error) => {
                this.commonService.modalOpens(error, (modalresult) => {});
              },
            );
          } else {
            return;
          }
        },
      );
    } else {
      let person_list = [];
      for (let i in this.selectedList) {
        var row = this.selectedList[i];
        person_list.push({
          id: row.t_person_id,
          name: row.name,
          code: row.code,
          t_event_id: this.selected_event_id,
          t_question_category_id: category[0]["t_question_category_id"],
          differencial_download: this.commonService.exchangeTFto01(
            this.differencialDownload,
          ),
        });
      }
      this.uploadService.DownloadUploadFile(person_list).subscribe(
        (res: any) => {
          if (res["fuel_status"] == "OK") {
          }
        },
        (error) => {
          this.commonService.modalOpens(error, (modalresult) => {});
        },
      );
    }
  }

  getFile(file_name: any, path: any): void {
    let param = {
      file_name: file_name,
      path: path,
    };
    this.uploadService.persondownloadFile(param);
  }

  getuploadFile(row): void {
    let param = {
      t_output_history_id: row.t_output_history_id,
      file_name: row.output_file_name,
      path: row.output_file_path,
    };
    this.uploadService.downloadFile(param);
  }

  //マイナビアップロードダウンロード(選択した人全員)
  saikendownloadAll(category): void {
    if (this.selected) {
      this.commonService.modalOpens(
        50005,
        //編集中の内容を破棄してもよろしいですか？
        (modalresult) => {
          if (modalresult == "OK") {
            let person_list = [];
            for (let i in this.selectedList) {
              var row = this.selectedList[i];
              person_list.push({
                id: row.t_person_id,
                name: row.name,
                code: row.code,
                t_event_id: this.selected_event_id,
                t_question_category_id: category[0]["t_question_category_id"],
              });
            }
            this.uploadService.SaikenDownloadUploadFile(person_list).subscribe(
              (res: any) => {
                if (res["fuel_status"] == "OK") {
                  this.selected = false;
                }
              },
              (error) => {
                this.commonService.modalOpens(error, (modalresult) => {});
              },
            );
          } else {
            return;
          }
        },
      );
    } else {
      let person_list = [];
      for (let i in this.selectedList) {
        var row = this.selectedList[i];
        person_list.push({
          id: row.t_person_id,
          name: row.name,
          code: row.code,
          t_event_id: this.selected_event_id,
          t_question_category_id: category[0]["t_question_category_id"],
        });
      }
      this.uploadService.SaikenDownloadUploadFile(person_list).subscribe(
        (res: any) => {
          if (res["fuel_status"] == "OK") {
          }
        },
        (error) => {
          this.commonService.modalOpens(error, (modalresult) => {});
        },
      );
    }
  }

  /** ファイル一覧モーダル表示 */
  isFileModalOpen = false;
  /** 仮：アップロードファイル一覧 */
  uploadFileList: any[] = [];
  SaikenuploadFileList: any[] = [];
  // 今どの person を見ているか
  selectedPerson: any = null;
  selectedPersonId: any;
  selectedPersonCode: any;

  /** backend に渡す用 */
  getSelectedData(): void {
    const selectedA = this.uploadFileList.filter((f) => f.checked);
    const selectedB = this.SaikenuploadFileList.filter((f) => f.checked);
    // ここで別変数として渡せる
    console.log("dataA", selectedA);
    console.log("dataB", selectedB);
  }

  openFileModal(d: any): void {
    this.selectedPerson = d;
    this.selectedPersonId = d["t_person_id"];
    this.selectedPersonCode = d["code2"];

    //  ここで振り分け
    this.uploadFileList = (d.upload_file || [])
      .filter((f: any) => f.upload_status === "1")
      .map((f: any) => ({
        ...f,
        checked: false,
      }));
    this.SaikenuploadFileList = (d.saiken_file || [])
      .filter((f: any) => f.saiken_upload_status === "1")
      .map((f: any) => ({
        ...f,
        checked: false,
      }));
    this.isFileModalOpen = true;
  }
  /** モーダルを閉じる */
  closeFileModal(): void {
    this.isFileModalOpen = false;
  }
  /** チェック済みファイルがあるか */
  hasCheckedFile(): boolean {
    return (
      this.uploadFileList.some((f) => f.checked) ||
      this.SaikenuploadFileList.some((f) => f.checked)
    );
  }
  /** ダウンロード押下 */
  downloadSelectedFiles(): void {
    const uploadselected = this.uploadFileList.filter((f) => f.checked);
    const saikenselected = this.SaikenuploadFileList.filter((f) => f.checked);
    if (uploadselected.length === 0 && saikenselected.length === 0) {
      return;
    }
    const uploadSelectedIds = uploadselected
      .map((f) => f.t_upload_maintenance_id)
      .join(",");
    const saikenSelectedIds = saikenselected
      .map((f) => f.t_saiken_file_id)
      .join(",");
    this.uploadService
      .PersonDownloadUploadFile(
        uploadSelectedIds,
        saikenSelectedIds,
        this.selectedPersonId,
        this.selectedPersonCode,
      )
      .subscribe(
        (res: any) => {
          if (res["fuel_status"] == "OK") {
            const file_name = res["fuel_results"]["file_name"]; // PHPから返されたダウンロードURL
            const path = res["fuel_results"]["path"];
            if (file_name) {
              // ここでブラウザに直接ダウンロードを指示
              this.getFile(file_name, path);
            }
          }
        },
        (error) => {
          this.commonService.modalOpens(error, (modalresult) => {});
        },
      );
    this.closeFileModal();
  }

  //マイナビアップロードまとめてダウンロード(選択した人全員)
  downloadBulkAll(category): void {
    this.commonService.modalOpens(
      53001,
      //ファイルを出力しますか？
      (modalresult) => {
        if (modalresult == "OK") {
          let person_list = [];
          for (let i in this.selectedList) {
            var row = this.selectedList[i];
            person_list.push(row.t_person_id);
          }
          let param = {
            t_event_id: this.selected_event_id,
            person_list: person_list,
            mode: 1,
            differencial_download: this.commonService.exchangeTFto01(
              this.differencialDownload,
            ),
          };
          this.uploadService.downloadUploadBulkFile(param).subscribe(
            (res: any) => {
              if (res["fuel_status"] == "OK") {
                this.selected = false;
              }
            },
            (error) => {
              this.commonService.modalOpens(error, (modalresult) => {});
            },
          );
        } else {
          return;
        }
      },
    );
  }

  // ファイルアップロード機能（管理者）マイナビ202607 start
  /**
   * 関連ファイル取込
   * @param list 
   */
  importKanren(list: any): void {
    this.commonService.modalOpens(54002, (modalresult) => {
      if (modalresult == "OK") {
        const f = list[0];
        // ファイルをセット
        const fd = new FormData();
        fd.append("upfile", f, f.name);
        fd.append("t_event_id", this.selected_event_id.toString());
        this.fileUploadService.importKanren(fd).subscribe((res: any) => {
          if (res["fuel_status"] == "OK") {
            this.commonService.modalOpens(10010, (modalresult) => {
              if (modalresult) {
                this.selectInputFile = "";
                this.file_selected = false;
              }
            });
          } else {
            this.commonService.modalOpens(res["fuel_message"], (modalresult) => {});
          }
        });
      }
    });
  }

  /**
   * 関連ファイル取込（差し替え）
   * @param list 
   */
  importKanrenReplace(list: any): void {
    this.commonService.modalOpens(54002, (modalresult) => {
      if (modalresult == "OK") {
        const f = list[0];
        // ファイルをセット
        const fd = new FormData();
        fd.append("upfile", f, f.name);
        fd.append("t_event_id", this.selected_event_id.toString());
        this.fileUploadService.importKanrenReplace(fd).subscribe((res: any) => {
          if (res["fuel_status"] == "OK") {
            this.commonService.modalOpens(10010, (modalresult) => {
              if (modalresult) {
                this.selectInputFile = "";
                this.file_selected = false;
              }
            });
          } else {
            this.commonService.modalOpens(res["fuel_message"], (modalresult) => {});
          }
        });
      }
    });
  }

  /**
   * PDF選択時の処理
   * @param {event} any     ファイル選択イベント
   * @param {index} number  再検査ファイルデータのインデックス
   * @returns
   */
  onKanrenFilesSelected(event: any, index: number) {
    this.addPdfFiles(event, this.editItem.kanren_file[index]);
  }

  /** 
   * 選択されたPDFを対象データへ追加する
   * @param {event} any     ファイル選択イベント
   * @param {target} any    対象データ
   */
  private addPdfFiles(event: any, target: any): void {
    const files = event.target.files || [];
    target.up_file = target.up_file || [];
    for (let i = 0; i < files.length; i++) {
      if (files[i].type === "application/pdf") {
        target.up_file.push(files[i]);
      }
    }
  }

  /**
   * 各行で選択されたPDFを結合し、API送信用のBase64へ変換する
   * @param items 
   */
  private async preparePdfFiles(items: any[]): Promise<void> {
    for (const item of items || []) {
      const files: File[] = item.up_file || [];
      if (files.length === 0) {
        continue;
      }

      const buffers = await Promise.all(
        files.map(file => this.pdfService.readAsArrayBuffer(file))
      );
      const merged = await this.pdfService.mergePdfs(buffers);
      const mergedBuffer = new ArrayBuffer(merged.byteLength);
      new Uint8Array(mergedBuffer).set(merged);
      const uploadFile = new File([mergedBuffer], "upload.pdf", {
        type: "application/pdf",
      });
      item.up_file_base_64 = await this.pdfService.fileToBase64(uploadFile);
    }
  }

  /**
   * 関連ファイル削除
   * @param index 
   */
  removeKanrenFile(index: number) {
    this.editItem.kanren_file[index].delete_flg = 1;
  }

  // ファイルアップロード機能（管理者）マイナビ202607 end
}



// WEBPACK FOOTER //
// ./src/app/a0108-person/person.component.ts